import * as Sentry from '@sentry/react'

interface Logger {
  debug: (...args: unknown[]) => void
  info: (...args: unknown[]) => void
  warn: (...args: unknown[]) => void
  error: (...args: unknown[]) => void
}

const noop = (): void => {}
const IS_DEV = import.meta.env.DEV

export function createLogger(tag: string): Logger {
  const prefix = `[${tag}]`
  return {
    debug: IS_DEV ? (...args: unknown[]) => console.log(prefix, ...args) : noop,
    info: IS_DEV ? (...args: unknown[]) => console.log(prefix, ...args) : noop,
    warn: (...args: unknown[]) => {
      console.warn(prefix, ...args)
      Sentry.captureMessage(
        `${prefix} ${args.map(String).join(' ')}`,
        'warning',
      )
    },
    error: (...args: unknown[]) => {
      console.error(prefix, ...args)
      const err = args.find((a) => a instanceof Error)
      if (err) {
        Sentry.captureException(err)
      } else {
        Sentry.captureMessage(
          `${prefix} ${args.map(String).join(' ')}`,
          'error',
        )
      }
    },
  }
}
